<template>
  <div>
    <div v-if="post.status !== 'published' && pendingPublishReservation">
      <div class="font-weight-bold mb-2">予約公開 設定済み</div>
      日時：{{ pendingPublishReservation.reservedAt | moment }}
      <v-btn
        class="mt-2"
        color="error"
        block
        tile
        outlined
        @click="deletePublishReservation"
      >
        予約を取り消す
      </v-btn>
    </div>
    <div v-else-if="post.status !== 'published'">
      <v-radio-group v-model="publishNow" dense>
        <div class="mb-3">
          <v-radio :value="true">
            <template v-slot:label> 今すぐ公開</template>
          </v-radio>
        </div>
        <div>
          <v-radio :value="false">
            <template v-slot:label>
              <div v-if="reserveDatetime == null">予約公開</div>
              <div v-else>
                {{ reserveDatetime | moment
                }}<span class="caption">に公開</span>
              </div>
            </template>
          </v-radio>
          <DatePickerDialog v-if="!publishNow" v-model="reserveDatetime">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                label="予約時間を選択"
                :value="reserveDatetime"
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </template>
          </DatePickerDialog>
        </div>
      </v-radio-group>
      <v-checkbox
        v-if="!!releasedOn"
        v-model="updatePublishedOn"
        label="公開日を更新する"
      />
      <v-btn color="success" depressed block @click="publishPost">
        <span class="font-weight-bold">
          <span v-if="publishNow">今すぐ</span>
          <span v-else>予約</span>
          公開する
        </span>
      </v-btn>
    </div>
    <div v-else-if="post.status === 'published'">
      <v-btn color="danger" depressed dark block @click="closePost">
        <span class="font-weight-bold">非公開にする</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import DatePickerDialog from './DatePickerDialog'

export default {
  components: { DatePickerDialog },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY年M月D日 HH時mm分')
    }
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      publishNow: true,
      updatePublishedOn: false,
      reserveDatetime: null
    }
  },
  computed: {
    ...mapState({
      releasedOn: (state) => state.PostEditor.post.releasedOn,
      pendingPublishReservation: (state) =>
        state.PostEditor.post.pendingPublishReservation
    })
  },
  methods: {
    publishPost () {
      if (this.publishNow) {
        this.$store.dispatch('PostEditor/publishPost', this.updatePublishedOn)
      } else {
        if (this.post.savedToDB) {
          this.$store.dispatch('PostEditor/publishReservation', {
            reserveDatetime: this.reserveDatetime,
            updateReleasedOn: this.updatePublishedOn
          })
        } else {
          const payload = {
            status: 402,
            message:
              '保存されていない変更があります。保存した後、公開予約をしてください。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      }
    },
    deletePublishReservation () {
      this.$store.dispatch(
        'PostEditor/deletePublishReservation',
        this.pendingPublishReservation.id
      )
    },
    closePost () {
      this.$store.dispatch('PostEditor/closePost')
    }
  }
}
</script>

<style scoped>
.timeSelectionRadio label[for] {
  height: 20px;
  font-size: 10px;
}
</style>
